import { default as statsConfigSelectors } from '../config/selectors';

import { dataTableSelectors } from './dataTable';
import { filterSelectors } from './filter';
import { reportSelectors } from './report';

/* genBaseUrl
 *
 * Generates the path to fetch stats data.
 */
const genBaseUrl = ({ reportName }, reportCategory) => {
    return `${window.__BASE_REST_URL__}/${reportCategory}/${reportName}`;
};

const genDataUrl = ({ playersAndTeams, config }) => {
    const { page, pageSize } = playersAndTeams.dataTable;

    const sortData = playersAndTeams.dataTable.sort;
    const reportCategory = playersAndTeams.report.reportCategory;
    const appliedReportData = playersAndTeams.report.applied;
    const filterState = playersAndTeams.filter;
    const { resultFilters } = statsConfigSelectors.getTimeSpecificDataOnReport(config, appliedReportData);

    // Get the query parameters and filter out any empty strings
    const queryParamsArr = [
        reportSelectors.genBaseReportCayenneParams(appliedReportData),
        dataTableSelectors.getSortAsQueryParams(reportCategory, sortData, appliedReportData),
        ...dataTableSelectors.getPaginationAsQueryParams(page, pageSize),
        filterSelectors.getCustomFiltersAsQueryParams(filterState.applied.customFilters, resultFilters),
    ].filter((param) => param);

    const queryParams = encodeURI(queryParamsArr.join('&'));

    const cayenneExpParams = [
        ...reportSelectors.genReportDetailsCayenneParams(appliedReportData),
        ...filterSelectors.getFiltersAsCayenneParams(filterState, reportCategory),
    ];

    // Sorting params for predictability, just a nice touch
    const cayenneExpString = `&cayenneExp=${cayenneExpParams.sort().join(encodeURI(' and '))}`;

    return `${genBaseUrl(appliedReportData, reportCategory)}${queryParams}${cayenneExpString}`;
};

const genDeeplinkUrl = ({ playersAndTeams }) => {
    const queryParams = [
        ...reportSelectors.getReportAsQueryParams(playersAndTeams.report.current),
        ...filterSelectors.getFiltersAsQueryParams(playersAndTeams.filter),
        dataTableSelectors.getSortAsDeeplinkParams(playersAndTeams.dataTable.sort),
        ...dataTableSelectors.getPaginationAsDeeplinkParams(
            playersAndTeams.dataTable.page,
            playersAndTeams.dataTable.pageSize,
        ),
    ].filter((x) => x);

    return `?${queryParams.join('&')}`;
};

export default {
    genDataUrl,
    genDeeplinkUrl,
};
